class CircleNumList {
  constructor(el, opt) {
    this.el = el;
    if ($("." + this.el).length > 0) {
      this.event();
    }
  }

  event() {
    document.querySelectorAll('.c-circle-num-list').forEach(list => {
      // 各リストごとに番号をリセットして再設定
      list.querySelectorAll('.c-circle-num-list__item').forEach((item, index) => {
        const circledNumbers = ['①', '②', '③', '④', '⑤', '⑥', '⑦', '⑧', '⑨', '⑩'];
        if (index < circledNumbers.length) {
          item.style.setProperty('--circle-num', `"${circledNumbers[index]}"`);
        } else {
          // circledNumbers の長さを超えた場合の対応（必要に応じて拡張）
          item.style.setProperty('--circle-num', `"${index + 1}"`);
        }
      });
    });
  }
}
